import _ from 'underscore';
import React, { useContext, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Panel } from '@fluentui/react';
import type { IPanelProps } from '@fluentui/react';

import { SidePanelContext } from './side-panel-context';

export interface SidePanelProps extends IPanelProps {
  isOpen: boolean;
}

export function SidePanel(props: SidePanelProps) {
  const { containerId, onPanelOpenStateChange } = useContext(SidePanelContext);

  const newProps = {
    onOuterClick: _.noop,
    ...props,
    layerProps: {
      ...props.layerProps,
      hostId: containerId,
    },
  };

  const panelId = useMemo(() => _.uniqueId('side-panel-'), []);
  const { isOpen } = props;

  useEffect(() => {
    onPanelOpenStateChange(panelId, isOpen);

    return () => onPanelOpenStateChange(panelId, false);
  }, [isOpen, onPanelOpenStateChange, panelId]);

  return (<Panel {...newProps} />);
}

SidePanel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  layerProps: PropTypes.shape({}),
};

SidePanel.defaultProps = {
  layerProps: null,
};
